import { platformIconPathById } from '../../../../../app.constants';
import { InteractionReportItem } from '../../../../../../models/measure/report';
import { UserService } from '../../../../../services/user.service';
import { PdfExportService } from '../../../../../services/export-pdf/pdf-export.service';
import { InteractionReportComponent } from '../interaction-report.component';
var InteractionReportItemComponent = /** @class */ (function () {
    function InteractionReportItemComponent(pdfService, userService) {
        this.pdfService = pdfService;
        this.userService = userService;
        this.interactionPost = new InteractionReportItem();
    }
    InteractionReportItemComponent.prototype.getPlatformIcon = function (platformId) {
        return platformIconPathById[platformId].path;
    };
    InteractionReportItemComponent.prototype.onLoadedImage = function () {
        this.pdfService.updateNumberImageLoaded("" + InteractionReportComponent.COMPONENT_NAME + this.pageOrderNo);
    };
    Object.defineProperty(InteractionReportItemComponent.prototype, "activeAccount", {
        get: function () {
            return this.userService.getCompanyId();
        },
        enumerable: true,
        configurable: true
    });
    return InteractionReportItemComponent;
}());
export { InteractionReportItemComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/contents/interaction-report/interaction-report-item/interaction-report-item.component.ts.pre-build-optimizer.js